<template>
    <div class="monitoring">
        <div class="container">
            <div class="monitoring__header">
                <h2>Мониторинг</h2>
                <p v-if="allCountUnseen >= 0 && allCountTotal >= 0">Кол-во новых изменений {{allCountUnseen}} из {{allCountTotal}}</p>
            </div>
            <div class="monitoring__sidebar">
                <div @click="showAddMonitoringModal = !showAddMonitoringModal" class="monitoring__sidebar_button"><i class="lnr lnr-file-add"></i>Добавить в мониторинг</div>
                <div v-if="showAddMonitoringModal">
                    <textarea v-model="ogrnUploadList" style="width: 100%" :placeholder="`Загрузка ОГРН кодов для добавления, каждый с новой строки.\n\nВам доступно ${monitoringLimit - allCompaniesOgrns} из ${monitoringLimit}`"></textarea>
                    <button @click="addMultipleOgrns" class="uk-button uk-button-primary">Добавить в мониторинг</button>
                </div>
                <div @click="downloadXLSX(null)" class="monitoring__sidebar_button"><i class="lnr lnr-download"></i>Скачать таблицу .xlsx</div>
                <div class="monitoring__sidebar-category">
                    <div class="monitoring__sidebar-category-header">Все категории</div>
                    <div @click="selectCategory(0)" class="monitoring__sidebar-category-switch-btn">Показать все</div>
                    <div @click="selectCategory(1)" :class="{'monitoring__sidebar-category-switch-btn': true, 'monitoring__sidebar-category-switch-btn_active': selectedCategory == 1}"><i class="far fa-eye"></i> Без категории</div>
                    <div @click="selectCategory(2)" :class="{'monitoring__sidebar-category-switch-btn': true, 'monitoring__sidebar-category-switch-btn_active': selectedCategory == 2}"><i class="fas fa-people-carry"></i> Поставщик</div>
                    <div @click="selectCategory(7)" :class="{'monitoring__sidebar-category-switch-btn': true, 'monitoring__sidebar-category-switch-btn_active': selectedCategory == 7}"><i class="fas fa-user-slash"></i> Недобросовестный поставщик </div>
                    <div @click="selectCategory(4)" :class="{'monitoring__sidebar-category-switch-btn': true, 'monitoring__sidebar-category-switch-btn_active': selectedCategory == 4}"><i class="fas fa-dolly-flatbed"></i> Клиент</div>
                    <div @click="selectCategory(5)" :class="{'monitoring__sidebar-category-switch-btn': true, 'monitoring__sidebar-category-switch-btn_active': selectedCategory == 5}"><i class="fas fa-hand-holding-usd"></i> Должник</div>
                    <div @click="selectCategory(3)" :class="{'monitoring__sidebar-category-switch-btn': true, 'monitoring__sidebar-category-switch-btn_active': selectedCategory == 3}"><i class="fas fa-ghost"></i> Конкурент</div>
                    <div @click="selectCategory(8)" :class="{'monitoring__sidebar-category-switch-btn': true, 'monitoring__sidebar-category-switch-btn_active': selectedCategory == 8}"><i class="fas fa-sitemap"></i> Аффилированная структура</div>
                    <div @click="selectCategory(6)" :class="{'monitoring__sidebar-category-switch-btn': true, 'monitoring__sidebar-category-switch-btn_active': selectedCategory == 6}"><i class="fas fa-crown"></i> VIP</div>
                </div>
            </div>
            <div class="monitoring__content">
                <div class="monitoring__content-search-block">
                    <input v-model="listFilterQuery" class="monitoring__content-search" value="" placeholder="Поиск по наименованию"/>
                    <i @click="listFilterQuery = ''" v-if="listFilterQuery" class="lnr lnr-cross"></i>
                </div>
                <shestirenkaLoader  v-if="loading" />
                <template v-else-if="monitoringCompanies.length">
                    <pagination v-if="pagination" :pagination="pagination" :onTurnPageCallBack="getCompanies" :showRowsPerPageSelection="true" :rows_on_page="monitoringCompanies.length" />
                    <table class="monitoring__content-table">
                        <thead>
                            <tr class="monitoring__content-table-header">
                                <th>
                                    <i @click="fillSelectedList" v-if="selectedList.length == 0" class="far fa-square" aria-hidden="true"></i>
                                    <i @click="clearSelectedList" v-else-if="selectedList.length > 0 && selectedList.length != monitoringCompanies.length" class="fas fa-minus-square" aria-hidden="true"></i>
                                    <i @click="clearSelectedList" v-else-if="selectedList.length > 0 && selectedList.length == monitoringCompanies.length" class="fas fa-check-square" aria-hidden="true"></i>
                                </th>
                                <th class="monitoring__content-table-header-category">
                                    <span class="blue-red-hover-text" @click="showChangeCategoryMenu = !showChangeCategoryMenu" v-if="selectedList.length">Изменить <i class="lnr lnr-chevron-down"></i></span>
                                    <span v-else>Категория</span>
                                    <ul v-if="showChangeCategoryMenu && selectedList.length">
                                        <li @click="setSelectedComapniesCategory(1)" class="blue-red-hover-text"><i class="far fa-eye"></i> Без категории</li>
                                        <li @click="setSelectedComapniesCategory(2)" class="blue-red-hover-text"><i class="fas fa-people-carry"></i> Поставщик</li>
                                        <li @click="setSelectedComapniesCategory(7)" class="blue-red-hover-text"><i class="fas fa-user-slash"></i> Недобросовестный поставщик</li>
                                        <li @click="setSelectedComapniesCategory(4)" class="blue-red-hover-text"><i class="fas fa-dolly-flatbed"></i> Клиент</li>
                                        <li @click="setSelectedComapniesCategory(3)" class="blue-red-hover-text"><i class="fas fa-ghost"></i> Конкурент</li>
                                        <li @click="setSelectedComapniesCategory(5)" class="blue-red-hover-text"><i class="fas fa-hand-holding-usd"></i> Должник</li>
                                        <li @click="setSelectedComapniesCategory(8)" class="blue-red-hover-text"><i class="fas fa-sitemap"></i> Аффилированная структура</li>
                                        <li @click="setSelectedComapniesCategory(6)" class="blue-red-hover-text"><i class="fas fa-crown"></i> VIP</li>
                                    </ul>
                                </th>
                                <th>
                                    <span class="blue-red-hover-text" v-if="selectedList.length" @click="deleteCompanies">Удалить выбранное из мониторинга</span>
                                    <span v-else>Наименование</span>
                                </th>
                                <th>Дата постановки <br> на мониторинг</th>
                                <!-- <th>Изменение</th> -->
                                <th>
                                    <div>Последнее изменение</div>
                                </th>
                                <th class="monitoring__content-table-header-changes">
                                    <template v-if="selectedList.length">
                                        <div @click="watchCompanies" class="blue-red-hover-text">Отметить как <br> прочитанное</div>
                                    </template>
                                    <template v-else>
                                        <div>Кол-во изменений</div>
                                        <div style="font-size: 12px">({{countUnseen}} из {{countTotal}})</div>
                                    </template>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="monitoring__content-table-item" v-for="(e,i) in monitoringCompanies" :key="i">
                                <td>
                                    <i v-if="selectedList.includes(e.company_id)" @click="removeFromSelectedList(e.company_id)" class="fas fa-check-square" aria-hidden="true"></i>
                                    <i v-else @click="addToSelectedList(e.company_id)" class="far fa-square" aria-hidden="true"></i>
                                </td>
                                <td style="text-align: center">
                                    <i :class="getCategoryIconClassName(e.category_id)" :title="getCategory(e.category_id)" style="font-size: 18px; width: auto; color: #555"></i>
                                </td>
                                <td class="monitoring__content-table-item-name">
                                    <div>
                                        <span>
                                            <i v-if="e.company_date_stop" class="uk-icon-times-circle" style="color: #e74c3c"></i>
                                            <i v-else class="uk-icon-check-circle" style="color: #2ecc71"></i>
                                        </span>
                                        <a v-if="e.company_id" :href="`/company/${e.company_id}`" target="_blank">
                                            <span v-if="e.company_name_short">{{e.company_name_short}}</span>
                                            <span v-else-if="e.company_name_full">{{e.company_name_full}}</span>
                                        </a>
                                        <span v-else>
                                            <span v-if="e.company_name_short">{{e.company_name_short}}</span>
                                            <span v-else-if="e.company_name_full">{{e.company_name_full}}</span>
                                        </span>
                                    </div>
                                    <div v-if="getCategoriesListItemByOgrn(e.company_id)">
                                        <span v-for="(e,i) in getCategoriesListItemByOgrn(e.company_id).categories" :key="i">
                                            <span :style="categoryStyleColor(e.id)">{{e.title}}</span> в {{e.groups.join(', ')}};
                                        </span>
                                    </div>
                                </td>
                                <td>
                                    <span v-if="e.started_at">{{new Date(e.started_at).toLocaleDateString()}}</span>
                                </td>
                                <td>
                                    <div>{{new Date(e.changed_at).toLocaleDateString()}}</div>
                                    <div v-if="e.change_type_title">{{e.change_type_title}}</div>
                                    <div v-else>—</div>
                                </td>
                                <td class="monitoring__content-table-item-changes">
                                    <div class="monitoring__content-table-item-changes-new">Новых {{e.count_unseen}}</div>
                                    <div class="monitoring__content-table-item-changes-all">Всего {{e.count_total}}</div>
                                    <div @click="showCompanyChanges(0, 50, e.company_id, (e.company_name_short ? e.company_name_short : e.company_name_full))" class="monitoring__content-table-item-changes-show">Показать</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <pagination v-if="pagination" :pagination="pagination" :onTurnPageCallBack="getCompanies" :showRowsPerPageSelection="true" :rows_on_page="monitoringCompanies.length" />
                </template>
                <template v-else>
                    <h3 style="margin: 10px 0">Компаний не найдено</h3>
                </template>
            </div>
        </div>
        <modal 
            v-if="showCompanyChangesModal" 
            :close="closeModalHandler" 
            :printButton="true" 
            :downloadButton="false"
        >
            <span slot="modalHeader">Список изменений <a :href="`/company/${comapnyChangesOGRN}`" target="_blank" style="border: 0">{{comapnyChangesName}}</a></span>
            <div slot="modalBody" style="padding: 10px">
                <pagination v-if="companyChangesPagination" :pagination="companyChangesPagination" :onTurnPageCallBack="getCompanyChanges" :showRowsPerPageSelection="true" :rows_on_page="companyChangesData.length" />
                <table class="simple-table">
                    <thead>
                        <tr>
                            <th>Изменение</th>
                            <th>Дата обновления информации</th>
                            <th>Старые данные</th>
                            <th>Новые данные</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(e,i) in companyChangesData" :key="i">
                            <td style="font-weight: 400">{{e.change_type_title}}</td>
                            <td>{{format_time(e.change_date)}}</td>
                            <td>
                                <template v-if="e.data_old && e.data_old.length && e.data_old.length > 0 && e.data_old[0] != null">
                                    <div v-for="(e,i) in e.data_old" :key="i">
                                        <p v-if="e.title" style="font-weight: 400; margin: 15px 0">{{e.title}}</p>
                                        <p v-if="e.value">{{e.value}}</p>
                                        <template v-if="e.attributes && e.attributes.length">
                                            <p v-for="(e,i) in e.attributes" :key="i" style="margin: 0">
                                                <span v-if="e.title">{{e.title}}:</span>
                                                <span v-if="e.value">{{e.value}}</span>
                                            </p>
                                        </template>
                                    </div>
                                </template>

                                <template v-else>—</template>
                            </td>
                            <td>
                                <template v-if="e.data_new && e.data_new.length && e.data_new.length > 0 && e.data_new[0] != null">
                                    <template v-if="e.change_type == '/КадНовый' && e.data_new[0].id">
                                        <a :href="`http://kad.arbitr.ru/Card/${e.data_new[0].id}`" target="_blank">{{e.data_new[0].number}}</a>
                                    </template>
                                    <template v-else>
                                        <div v-for="(e,i) in e.data_new" :key="i">
                                            <p v-if="e.title" style="font-weight: 400; margin: 15px 0">{{e.title}}</p>
                                            <p v-if="e.value">{{e.value}}</p>
                                            <template v-if="e.attributes && e.attributes.length">
                                                <p v-for="(e,i) in e.attributes" :key="i" style="margin: 0">
                                                    <span v-if="e.title">{{e.title}}:</span>
                                                    <span v-if="e.value">{{e.value}}</span>
                                                </p>
                                            </template>
                                        </div>
                                    </template>
                                </template>

                                <template v-else>—</template>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <pagination v-if="companyChangesPagination" :pagination="companyChangesPagination" :onTurnPageCallBack="getCompanyChanges" :showRowsPerPageSelection="true" :rows_on_page="companyChangesData.length" />
            </div>
            <button slot="modalFooter" @click="downloadXLSX(comapnyChangesOGRN)" class="uk-button"><i class="lnr lnr-download"></i> Сохранить в .xlsx</button>
        </modal>
    </div>
</template>

<script>
import { getQueryStringValue } from '@/helpers'
import monitoringSetDeleteButton from './monitoringSetDeleteButton.vue'
import modal from '@/components/ui/modal.vue'
import shestirenkaLoader from '@/components/ui/shestirenkaLoader.vue'
import pagination from '@/components/ui/pagination.vue'

export default {
    components: {
        monitoringSetDeleteButton,
        modal,
        shestirenkaLoader,
        pagination
    },
    data() {
        return {
            ogrnUploadList: '',
            showAddMonitoringModal: false,
            showChangeCategoryMenu: false,
            listFilterQuery: '',
            selectedList: [],
            selectedCategory: 0,
            downloadlXLSXLoading: false,
            showCompanyChangesModal: false,
            comapnyChangesName: '',
            comapnyChangesOGRN: null,
            companyChangesData: null,
            companyChangesPagination: null,
            companyChangesLoading: false,
            order_by: 'changed_at',
            order_type: 'desc'
        }
    },
    methods: {
        getCategoriesListItemByOgrn(ogrn) {
            return this.$store.getters['monitoring/getCategoriesListItemByOgrn'](ogrn)
        },
        categoryStyleColor(categoryId) {
            const conditional = categoryId == 5 || categoryId == 7 || categoryId == 8
            return { color: conditional ? 'red' : '' }
        },
        sortBy(order_by) {
            if(this.order_by == order_by) {
                if(this.order_type == 'asc') {
                    this.order_type = 'desc'
                } else if(this.order_type == 'desc') {
                    this.order_type = 'asc'
                }
            } else {
                console.log('else else')
                this.order_by = order_by
                this.order_type = 'desc'
            }
            this.getCompanies()
        },
        getCategory(category_id){
            switch(category_id) {
                case 1:
                    return "Без категории"
                    break;
                case 2:
                    return "Поставщик"
                    break;
                case 3:
                    return "Конкурент"
                    break;
                case 4:
                    return "Клиент"
                    break;
                case 5:
                    return "Должник"
                    break;
                case 6:
                    return "VIP"
                    break;
                case 7:
                    return "Недобросовестный поставщик"
                    break;
                case 8:
                    return "Аффилированная структура"
                    break;
            }
        },
        getCategoryIconClassName(category_id) {
            let className = [];
            switch(category_id) {
                case 1:
                    className = ["far", "fa-eye"]
                    break;
                case 2:
                    className = ["fas", "fa-people-carry"]
                    break;
                case 3:
                    className = ["fas", "fa-ghost"]
                    break;
                case 4:
                    className = ["fas","fa-dolly-flatbed"]
                    break;
                case 5:
                    className = ["fas", "fa-hand-holding-usd"]
                    break;
                case 6:
                    className = ["fas", "fa-crown"]
                    break;
                case 7:
                    className = ["fas", "fa-user-slash"]
                    break;
                case 8:
                    className = ["fas", "fa-sitemap"]
                    break;
            }
            return className.filter(Boolean)
        },
        selectCategory(category_id) {
            this.selectedList = []
            this.selectedCategory = category_id
            this.$store.dispatch('monitoring/getCompanies', { limit: 50, offset: 0, category_id })
        },
        setSelectedComapniesCategory(category_id){
            this.$store.dispatch('monitoring/setCategory', { companies: this.selectedList, category_id }).then(e => {
                if(e) {
                    this.showChangeCategoryMenu = false
                    this.selectedList = []
                }
            })
        },
        addMultipleOgrns() {
            const ogrns = this.ogrnUploadList.split('\n').filter(Boolean)
            this.$store.dispatch('monitoring/addCompanies', ogrns).then(e => {
                if(e) {
                    this.ogrnUploadList = ''
                    this.showAddMonitoringModal = false
                }
            })
        },
        format_time(time) {
            time += "";
            return time[6] + time[7] + "." + time[4] + time[5] + "." + time[0] + time[1] + time[2] + time[3];
        },
        downloadXLSX(company_id){
            this.downloadlXLSXLoading = true
            this.$store.dispatch('monitoring/downloadXLSX', company_id).finally(() => { this.downloadlXLSXLoading = false })
        },
        getCompanies(offset = 0, limit = 50, category_id = this.selectedCategory){
            const { order_by, order_type } = this
            this.listFilterQuery = ''
            this.$store.dispatch('monitoring/getCompanies', {
                offset,
                limit,
                category_id,
                order_by,
                order_type
            })
        },
        deleteCompanies(){
            this.$store.dispatch('monitoring/removeCompanies', this.selectedList).then(() => {
                this.selectedList = []
            })
        },
        watchCompanies(){
            this.$store.dispatch('monitoring/watchCompanies', this.selectedList).then(() => {
                this.selectedList = []
            })
        },
        showCompanyChanges(offset = 0, limit = 50, company_id, company_name){
            this.companyChangesData = null
            this.comapnyChangesName = company_name
            this.comapnyChangesOGRN = company_id
            this.selectedList = []
            this.getCompanyChanges(offset, limit)
        },
        getCompanyChanges(offset = 0, limit = 50){
            this.companyChangesLoading = true
            this.$store.dispatch('monitoring/getCompanyChanges', { offset: offset, limit, company_id: this.comapnyChangesOGRN }).then(e => {
                if(e) {
                    this.companyChangesData = e.data
                    this.companyChangesPagination = e.pagination
                    this.showCompanyChangesModal = true
                }
            }).finally(() => {
                this.companyChangesLoading = false
            })
        },
        addToSelectedList(company_id) { this.selectedList = Array.from(new Set([...this.selectedList, company_id])) },
        removeFromSelectedList(company_id) { this.selectedList = this.selectedList.filter(e => e != company_id) },
        clearSelectedList() { this.selectedList = [] },
        fillSelectedList() { this.selectedList = this.$store.state.monitoring.company.map(e => e.company_id) },
        closeModalHandler() {
           this.showCompanyChangesModal = false 
           this.comapnyChangesName = '' 
           this.comapnyChangesOGRN = null 
        }
    },
    mounted(){
        if(window.auth) {
            const company_id = getQueryStringValue('company_id')
            const company_name = getQueryStringValue('company_name')

            if(company_id && company_name) {
                this.showCompanyChanges(0, 50, company_id, company_name)
            }
        }
    },
    computed: {
        monitoringCompanies(){
            const companies = this.$store.state.monitoring.company
            const query = this.listFilterQuery.toLowerCase()

            if(companies.length) {
                return companies.filter(e => e.company_name_full ? e.company_name_full.toLowerCase().includes(query) : null).filter(Boolean)
            } else {
                return []
            }
        },
        loading() { return this.$store.state.monitoring.loading },
        companies() { return this.$store.state.monitoring.company },
        allCompaniesOgrns() { return this.$store.getters["monitoring/allCompaniesOgrns"] ? this.$store.getters["monitoring/allCompaniesOgrns"].length : 0 },
        showMonitoringModal() { return this.$store.state.modals.monitoring },
        countUnseen() { return this.$store.getters["monitoring/countUnseen"] },
        countTotal() { return this.$store.getters["monitoring/countTotal"] },
        allCountUnseen() { return this.$store.getters["monitoring/allCountUnseen"] },
        allCountTotal() { return this.$store.getters["monitoring/allCountTotal"] },
        pagination() { return this.$store.state.monitoring.pagination },
        monitoringLimit() {
            if(this.$store.state.user.subscribes && this.$store.state.user.subscribes.length && this.$store.state.user.subscribes[0].monitoring_limit) {
                return this.$store.state.user.subscribes[0].monitoring_limit
            } else {
                return 1000
            }
        }
    }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables.sass'

$sidebar-width: 280px

.monitoring
    margin-top: $header-height
    width: 100%
    background-color: white
    min-height: calc(100% - #{$header-height})
    z-index: 2
    padding: 50px 0
    font-family: Gotham Pro, sans-serif
    .fas, .fab, .far
        display: inline-block
        width: 20px
        text-align: center
    &__header
        h2
            font-size: 44px
            font-weight: 800
            @media screen and (max-width: $desktop-resolution)
                font-size: 32px
                text-align: center
    &__sidebar, &__content
        display: inline-block
        margin-top: 20px
        font-size: 16px
        vertical-align: top
    &__sidebar
        width: $sidebar-width
        textarea
            padding: 5px
            border: 1px solid gray
            border-radius: 6px
            overflow: auto
            min-height: 200px
            outline: none
            -webkit-box-shadow: none
            -moz-box-shadow: none
            box-shadow: none
            resize: none
        &_button
            margin: 8px 0
            font-weight: 400
            cursor: pointer
            &:hover
                color: #4285F4
        .lnr, .fas, .fab
            color: #4285F4
            font-size: 20px
            margin-right: 10px
        &-category
            margin-top: 25px
            .lnr, .fas, .fab, .far
                color: #333
                font-size: 14px
                margin-right: 5px
            &-switch-btn,
            &-header
                margin-top: 5px
            &-switch-btn
                // padding-left: 20px
                font-size: 14px
                font-weight: 400
                cursor: pointer
                &_active
                    color: lighten(#4285F4, 20%)
                    .lnr, .fas, .fab, .far
                        color: lighten(#4285F4, 20%)
                &:hover
                    color: #4285F4
                    .lnr, .fas, .fab, .far
                        color: #4285F4
            &-header
                font-weight: bold
        @media screen and (max-width: $desktop-resolution)
            margin: 20px auto
            display: block
    &__content
        font-size: 14px
        width: calc(100% - #{$sidebar-width + 80px})
        margin-left: 50px
        margin-bottom: 50px
        @media screen and (max-width: 1280px)
            width: 780px
            margin-left: 10px
        @media screen and (max-width: 1024px)
            width: 720px
            margin-left: 0
        &-sort
            font-weight: 400
            font-size: 13px
            margin: 5px 0
            &-item
                @extend .blue-red-hover-text
                margin-right: 10px
                i.fas
                    margin-right: -3px
                    vertical-align: middle
        &-search-block
            position: relative
            .lnr.lnr-cross
                position: absolute
                top: 12px
                font-size: 22px
                right: 16px
                cursor: pointer
        &-search
            margin-bottom: 10px
            background: rgba(173, 203, 252, 0.46)
            width: 100%
            height: 46px
            line-height: 46px
            border-radius: 6px
            border: 0
            padding: 0 20px
        &-table
            width: 100%
            font-weight: 400
            font-size: 13px
            &-item
                &-name
                    font-weight: 500
                    text-decoration: none
                    width: 400px
                    font-size: 14px
                    a
                        border: 0
                &-date
                &-changes
                    &-new
                    &-all
                        color: #9D9D9D
                        font-weight: 300
                    &-show
                        text-decoration: none
                        color: rgba(30, 139, 195,1.0)
                        cursor: pointer
                        border: 0
                        &:hover
                            color: rgba(255,50,50,1.0)
            .fas.fa-check-square,
            .far.fa-square,
            .fas.fa-minus-square
                // font-family: "Font Awesome 5 Free"
                color: #639DFF
                font-size: 20px
                cursor: pointer
                width: 22px
                height: 22px
                display: inline-block
                &::hover
                    color: #4285F4
            td
                padding: 10px 15px
                vertical-align: top
            &-header
                th
                    text-align: left
                    padding: 10px 15px
                    vertical-align: top
                    white-space: nowrap
                    font-weight: 500
                    height: 56px 
                &-changes
                    min-width: 160px
                &-category
                    position: relative
                    min-width: 120px
                    text-align: center !important
                    ul
                        text-align: left
                        position: absolute
                        top: 20px
                        left: 10px
                        background-color: #fff
                        padding: 10px
                        border: 1px solid lightgray
                        border-radius: 6px
                        li:not(:first-child)
                            margin-top: 8px
                .lnr.lnr-chevron-down
                    font-weight: bold
                    font-size: 12px
                    vertical-align: middle
</style>